import React from "react";
import LoginForm from "../components/LoginForm";
const Login = ({ form, onChange, onSubmit }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
    <div className="flex flex-col items-center justify-center bg-gray-100 rounded-tl-lg rounded-bl-lg p-4">
      <div className="my-8">
        <img src="images/logo.svg" alt="JT Devs" width="400" height="400" />
      </div>
      <div className="flex flex-col items-center gap-8">
        <h1 className="text-4xl font-bold text-gray-900">Bienvenido</h1>
      </div>
      <div className="my-14">
        <p className="text-center relative text-gray-500 bg-gray-100 before:max-w-[50px] md:before:max-w-[120px] before:w-full before:-left-[60px] md:before:-left-[140px] before:h-[1px] before:bg-current before:absolute before:top-[50%] after:max-w-[50px] md:after:max-w-[120px] after:w-full after:h-[1px] after:bg-current after:absolute after:top-[50%] after:-right-[60px] md:after:-right-[140px]">
          Ingrese con RUC
        </p>
      </div>
      <div className="w-full mb-8">
        <LoginForm onChange={onChange} onSubmit={onSubmit} form={form} />
      </div>
    </div>
    <div className="hidden lg:flex items-center justify-center border-t border-r border-b rounded-tr-lg rounded-br-lg p-10">
      <img
        src="/images/login.banner.svg"
        className="w-full object-cover"
        alt="Banner"
      />
    </div>
  </div>
);
export default Login;